<template>
  <div>
    <div v-if="hasDataFailMessage()">
      <h1 class="data-fail-message">{{ getDataFailMessage() }}</h1>
      <p v-if="hasDataFailMessage2()" class="data-fail-message-sub">{{ getDataFailMessage2() }}</p>
    </div>
    <div v-show="!hasDataFailMessage()">
      <b-container class="d-flex justify-content-center align-items-start min-vh-100">
        <b-modal id="bonusModal" title="Hinweis">
          <p>Der Bonus muss immer größer oder gleich dem vorherigen sein!</p>
        </b-modal>
        <b-row class="w-100 justify-content-center">
          <b-col cols="12" md="8" lg="6">
            <table class="table table-bordered table-striped">
              <thead>
              <tr>
                <th>Stufe</th>
                <th>Aufträge (KWs)</th>
                <th>Bonus</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in provisionStufen" :key="index">
                <td>{{ row.stufe }}</td>
                <td>{{ row.auftraege }}</td>
                <td>
                  <div class="input-group">
                    <input type="number" class="form-control" v-model="row.bonus"/>
                    <span class="input-group-text">€</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <b-button variant="primary" @click="saveData">Speichern</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import provision from "../../api/kpi-energie-api/provision"

export default {
  name: 'PageProvisionsStufenVerwaltung',
  metaInfo() {
    return {
      title: 'Provisionsstufenverwaltung'
    }
  },
  data() {
    return {
      provisionStufen: []
    };
  },
  methods: {
    saveData() {
      if (this.provisionStufen.every((item, index) => {
        return index === 0 || Number(item.bonus) >= Number(this.provisionStufen[index - 1].bonus);
      })) {
        provision.postProvisionsStufen(this.provisionStufen)
      } else {
        this.$bvModal.show("bonusModal");
      }
    },
    hasDataFailMessage() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG && process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG !== ''
    },
    getDataFailMessage() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG
    },
    hasDataFailMessage2() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG_2 && process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG_2 !== ''
    },
    getDataFailMessage2() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSSTUFENVERWALTUNG_2
    },
  },
  created() {
    provision.getProvisionsStufen().then((response) => {
      this.provisionStufen = response.data;
    })
  }
}
</script>

<style scoped>
.data-fail-message {
  margin-top: 15px;
  text-align: center;
  font-size: 20px;
}
.data-fail-message-sub {
  text-align: center;
  font-size: 16px;
}
</style>
